<div class="c-card damage-card text-center image-container">
    <div>
        <img class="" src="{{wybierzObrazDlaLokalizacji()}}">
    </div>

    <div class="mt-5 text-center card-fill">
    </div>
</div>
